<template>
  <div class="my-nominees">
    <div class="row">
      <div class="col-md-9">
        <h2>My Nominees</h2>
        <div class="table-row">
          <div style="text-wrap: nowrap;">
            <div>Financial Year:</div>
            <div
              class="financial-year-container"
              v-for="n in financialYears"
              :key="n"
            >
              <div class="financial-year">
                <radio
                  :value="n"
                  name="financial-year"
                  v-model="currentFinancialYear"
                />
                <div class="financial-year-label margin-top-x4">
                  {{ `${n} - ${n + 1}` }}
                </div>
              </div>
              <div class="line"></div>
            </div>
          </div>
          <div>
            <div class="notice-area">
              重要提醒：優待機票之使用及提名nominees，請遵循人事業務手冊_9-6員工優待機票申請及使用規定，以免違反規定而受裁處。
              Important reminder: For the use of Staff benefit tickets, please
              follow the 9-6 employee benefit ticket application and use
              regulations, so as not to be punished for violating the
              regulations.
            </div>
          </div>
        </div>
        <div class="row nominee-info">
          <div class="col-sm-8">
            <div class="row">
              <div class="col-xs-6">
                <div class="row">
                  <div
                    class="col-sm-6"
                    v-if="currentAvailableNominees[nomineeType.spouse]"
                  >
                    <div class="vertical-middle">
                      <img :src="images.spouse" alt />
                      <div class="text-center">
                        <div>Spouse</div>
                        <div class="quantity">
                          {{
                            currentAvailableNominees[nomineeType.spouse].used
                          }}/{{
                            currentAvailableNominees[nomineeType.spouse].maximum
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6"
                    v-if="currentAvailableNominees[nomineeType.travelbuddy]"
                  >
                    <div class="vertical-middle">
                      <img :src="images.spouse" alt />
                      <div class="text-center">
                        <div>{{ nomineeTypeMap[nomineeType.travelbuddy] }}</div>
                        <div class="quantity">
                          {{
                            currentAvailableNominees[nomineeType.travelbuddy]
                              .used
                          }}/{{
                            currentAvailableNominees[nomineeType.travelbuddy]
                              .maximum
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6"
                    v-if="currentAvailableNominees[nomineeType.parents]"
                  >
                    <div class="vertical-middle">
                      <img :src="images.parent" alt />
                      <div class="text-center">
                        <div>{{ nomineeTypeMap[nomineeType.parents] }}</div>
                        <div class="quantity">
                          {{
                            currentAvailableNominees[nomineeType.parents].used
                          }}/{{
                            currentAvailableNominees[nomineeType.parents]
                              .maximum
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="row">
                  <div
                    v-show="showFriends"
                    class="col-sm-6"
                    v-if="currentAvailableNominees[nomineeType.friends]"
                  >
                    <div class="vertical-middle">
                      <img :src="images.friend" alt />
                      <div class="text-center">
                        <div>{{ nomineeTypeMap[nomineeType.friends] }}</div>
                        <div class="quantity">
                          {{
                            currentAvailableNominees[nomineeType.friends].used
                          }}/{{
                            currentAvailableNominees[nomineeType.friends]
                              .maximum
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6"
                    v-if="currentAvailableNominees[nomineeType.childOfEmployee]"
                  >
                    <div class="vertical-middle">
                      <img :src="images.child" alt />
                      <div class="text-center">
                        <div class="no-wrap">
                          {{ nomineeTypeMap[nomineeType.childOfEmployee] }}
                        </div>
                        <div class="quantity">
                          {{
                            currentAvailableNominees[
                              nomineeType.childOfEmployee
                            ].used
                          }}/{{
                            currentAvailableNominees[
                              nomineeType.childOfEmployee
                            ].maximum
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="ableToAdd" class="col-sm-4">
            <ttw-button
              class="add-btn col-xs-offset-2 col-xs-8"
              @click="addNominee"
              value="Add New"
            />
            <ripple class="fab add-btn-small" @click="addNominee">
              <img style="width:1.5rem;" :src="images.plus" alt />
            </ripple>
          </div>
        </div>
        <div>
          Financial Year:
          <b>{{ currentFinancialYear }} - {{ currentFinancialYear + 1 }}</b>
        </div>
        <div>
          These nominees are eligible to travel
          <b
            >from 01 Apr {{ currentFinancialYear }} to 31 Mar
            {{ currentFinancialYear + 1 }}</b
          >
        </div>
        <div class="notice">
          To update the nominee's passport number and expiry date, click the
          card below.
        </div>
        <div class="row nominee-info">
          <nominee-card
            :key="index"
            :nominee="nominee"
            @clickEdit="editNominee"
            :country-map="countryMap"
            @clickDelete="setDeletePopup"
            :removable="ableToRemoveNominee"
            v-for="(nominee, index) in nominees.filter(
              (n) => n.financialYear === currentFinancialYear
            )"
          />
        </div>
      </div>
      <div class="col-md-3">
        <side-bar />
      </div>
    </div>
    <notice-for-add
      v-if="ableToAdd"
      v-show="noticeModal"
      @escape="cancelNotice"
      @complete="cancelAndSaveNotice"
    />
    <add-nominee
      @close="hideModal"
      @escape="hideModal"
      @complete="hideModal"
      :nominee-status="nomineeStatus"
      v-if="ableToAdd && addNomineeModal"
      :start-year="currentFinancialYear"
    />
    <edit-nominee
      @close="hideModal"
      @escape="hideModal"
      @complete="hideModal"
      v-show="editNomineeModal"
      :nominee-id="nomineeId"
    />
    <modal
      :showCloseIcon="true"
      @close="hideModal"
      @escape="hideModal"
      v-show="deleteId"
    >
      <div slot="header" class="emphasize margin-bottom-x2">Notice！</div>
      <div slot="body">
        <div class="desc margin-bottom-x2">
          Are you sure you want to delete ?
        </div>
        <div class="margin-bottom-x2">
          <ttw-button
            @click="remove"
            _class="dark-red-bg"
            class="margin-right-x2"
            value="Confirm"
          />
          <ttw-button
            @click="hideModal"
            _class="light-black-bg"
            value="Cancel"
          />
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import images from "../../core/images";
import AddNominee from "./AddNominee";
import EditNominee from "./EditNominee";
import NoticeForAdd from "./NoticeForAdd";
import { mapState, mapMutations } from "vuex";
import Modal from "../../components/layout/Modal";
import NomineeCard from "@/components/card/NomineeCard";
import {
  nomineeType,
  marialStatus,
  nomineeStatus,
  nomineeTypeMap,
  employeementType,
} from "../../core/enum.js";

export default {
  components: {
    Modal,
    AddNominee,
    EditNominee,
    NomineeCard,
    NoticeForAdd,
  },
  created() {
    let uuid = "";
    // 已婚，刪除 travel buddy
    if (this.userInfo.marital === marialStatus.married) {
      uuid = this.nominees.find(
        (x) =>
          x.nominee_type === nomineeType.travelbuddy &&
          x.nomineeStatus === nomineeStatus.approved
      )?.uuid;
      // 未婚，刪除 spouse
    } else {
      uuid = this.nominees.find(
        (x) =>
          x.nominee_type === nomineeType.spouse &&
          x.nomineeStatus === nomineeStatus.approved
      )?.uuid;
    }
    new Promise((rs) => {
      if (uuid) {
        this.$staff.deleteNominee(this.token, uuid).then(() => rs());
      } else {
        rs();
      }
    }).then(() =>
      this.$staff.getNominees(this.token).then((r) => this.setNominees(r.data))
    );

    this.financialYears.forEach((x) =>
      this.$staff
        .getSummary(x)
        .then((r) => this.setAvailableNominees({ year: x, data: r.data }))
    );
    this.currentFinancialYear = this.financialYear;
  },
  data() {
    return {
      deleteId: null,
      ableToAdd: true,
      nomineeId: null,
      noticeModal: false,
      addNomineeModal: false,
      editNomineeModal: false,
      nomineesCountPerType: {},
      currentFinancialYear: null,
    };
  },
  watch: {
    currentFinancialYear(val) {
      this.setFinancialYear(val);
    },
    nomineeStatus(val) {
      this.ableToAdd = val.length > 0;
    },
  },
  methods: {
    addNominee() {
      if (this.showNotice) {
        this.noticeModal = true;
      } else {
        this.addNomineeModal = true;
      }
    },
    cancelNotice() {
      if (this.noticeModal) {
        this.noticeModal = false;
        this.addNomineeModal = true;
      }
    },
    cancelAndSaveNotice(status) {
      if (this.noticeModal) {
        this.setNomineeNotice(!status);
        this.noticeModal = false;
        this.addNomineeModal = true;
      }
    },
    hideModal() {
      this.deleteId = null;
      this.nomineeId = null;
      this.noticeModal = false;
      this.addNomineeModal = false;
      this.editNomineeModal = false;
    },
    editNominee(id) {
      this.nomineeId = id;
      this.editNomineeModal = true;
    },
    remove() {
      if (!this.deleteId) {
        return;
      }
      let id = this.deleteId;
      this.hideModal();
      this.$staff
        .deleteNominee(this.token, id)
        .then((resp) => {
          if (resp.status === 200) {
            this.deleteNominee(id);
            // 不等待
            this.$staff
              .getNominees(this.token)
              .then((r) => this.setNominees(r.data));
          }
        })
        .catch((ex) =>
          this.setMessagePopup({
            title: this.$text.errorMessageTitle,
            message: ex?.response?.data?.Description ?? ex.message,
          })
        );
    },
    setDeletePopup(uuid) {
      if (uuid) {
        this.deleteId = uuid;
      }
    },
    ...mapMutations([
      "setNominees",
      "deleteNominee",
      "setMessagePopup",
      "setFinancialYear",
      "setNomineeNotice",
      "setAvailableNominees",
    ]),
  },
  computed: {
    images: () => images,
    nomineeType: () => nomineeType,
    nomineeTypeMap: () => nomineeTypeMap,
    ableToRemoveNominee() {
      return (
        this.financialYears.length > 1 &&
        this.financialYear === this.financialYears[0]
      );
    },
    ...mapState({
      token: (s) => s.token,
      userInfo: (s) => s.userInfo,
      nominees: (s) => s.nominees,
      financialYear: (s) => s.financialYear,
      financialYears: (s) => s.financialYears,
      showNotice: (s) => s.showAddNomineeNotice,
      availableNominees: (s) => s.availableNominees,
      employeementType: (s) => s.userInfo?.employmentType,
      currentAvailableNominees: (s) =>
        s.availableNominees[s.financialYear]
          ? s.availableNominees[s.financialYear]
          : null,
      showFriends() {
        return this.employeementType === employeementType.fulltime;
      },
      nomineeStatus: (s) => {
        let status = [];
        let nominees = s.availableNominees[s.financialYear];
        for (let n in nominees) {
          let current = nominees[n];
          if (current.used < current.maximum) {
            status.push({ key: n, value: nomineeTypeMap[n] });
          }
        }
        return status;
      },
      countryMap: (s) => {
        let obj = {};
        Object.entries(s.countries).forEach((x) => (obj[x[0]] = x[1].name));
        return obj;
      },
    }),
  },
};
</script>
<style lang="scss">
.my-nominees {
  .notice-area {
    color: red;
    margin: 0.5rem;
    padding: 0.5rem;
    max-width: 48vw;
    font-weight: bold;
    margin-left: 1.5rem;
    background: #fff;
    border-radius: 0.25rem;
    text-decoration: underline;
    border: solid 0.15rem #aaa;
  }

  .financial-year-container {
    display: inline-block;

    .financial-year {
      text-align: center;
      display: inline-block;
      // .financial-year-label {
      //   //
      // }
    }

    .line {
      float: right;
      width: 10rem;
      height: 1.75rem;
      margin-left: -1.5rem;
      margin-right: -1rem;
      border-bottom: solid 1px $light-black;
    }

    &:last-child {
      div.line {
        width: 0;
      }
    }
  }

  .add-btn {
    button {
      background-color: $light-yellow;
    }
  }

  .add-btn-small {
    right: 7%;
    bottom: 5%;
    display: none;
    position: fixed !important;
  }

  @media (max-width: 767px) {
    .add-btn {
      display: none;
    }

    .add-btn-small {
      display: flex;
    }
  }

  .nominee-info {
    margin-top: 1rem;
    margin-bottom: 1rem;

    .vertical-middle {
      img {
        height: 3.5rem;
        margin-right: 0.5rem;
      }

      .quantity {
        color: $blue;
        font-size: 1.5rem;
        font-weight: bold;
        letter-spacing: 2px;
      }
    }
  }

  .notice {
    color: $light-black;
    margin-top: 0.75rem;
    font-size: 0.925rem;
    margin-bottom: 0.75rem;
  }
}
</style>
